module.exports = "/images/get-more-foot-traffic.svg?15fecd4cfbb7e32c6f582dba4d2b46b2";